import { render } from "./Cart-item.vue?vue&type=template&id=537312b2&scoped=true"
import script from "./Cart-item.vue?vue&type=script&lang=js"
export * from "./Cart-item.vue?vue&type=script&lang=js"

import "./Cart-item.vue?vue&type=style&index=0&id=537312b2&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537312b2"]])

export default __exports__